import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e53cc23"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "extra-plus"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "33",
  height: "33",
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.8125 16.5H31.1835",
    stroke: "#FBFAF7",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.5 1.81445V31.1854",
    stroke: "#FBFAF7",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 1,
  width: "81",
  height: "24",
  viewBox: "0 0 81 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14.4621 22.9257L1.16833 12.1396",
  stroke: "white",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M1.16833 11.8817L14.4621 1.07422",
  stroke: "white",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M80 12H1",
  stroke: "white",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]

import { useInterviewStore } from '@/stores/interviewStore'
import { computed, onMounted, ref } from 'vue'
import { scrollToElementBottom } from '../InterviewQuestionary/scrollToElementBottom';


export default /*#__PURE__*/_defineComponent({
  __name: 'FlatButton',
  props: {
    modelValue: null,
    bgColor: { default: '#315e3d' },
    isPlusActive: { type: Boolean, default: false },
    isArrowStyle: { type: Boolean, default: false },
    addFileBtn: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['click'],
  setup(__props: any, { emit: emits }) {

const props = __props as { modelValue: string, bgColor: string, isPlusActive: boolean, isArrowStyle: boolean, addFileBtn: boolean, disabled: boolean };




const root = ref<HTMLElement | undefined>(undefined)
onMounted(() => scrollToElementBottom(root!.value as HTMLElement));

const interviewStore = useInterviewStore()

async function onClick(event: Event) {
    // The native disabled attribute already blocks user clicks; this guards the
    // programmatic path, since this handler can also submit the whole questionary.
    if (props.disabled) {
        return
    }

    emits('click', event)

    if (interviewStore.isQuestionaryCompleted) {
        await submitQuestionaery()
    }
}

async function submitQuestionaery() {
    await interviewStore.postQuestionaryAnswers()
}

const endButtonText = computed(() => interviewStore.getLocalization('InterviewQuestionary.EndButton'))
const btnText = computed(() => {
    if (interviewStore.isLastQuestion) {
        return endButtonText.value
    }

    return props.modelValue
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    ref_key: "root",
    ref: root,
    onClick: onClick,
    disabled: __props.disabled,
    class: _normalizeClass(["next-question-btn", { arrow: !!__props.isArrowStyle, plus: !!__props.isPlusActive, 'add-file-btn': __props.addFileBtn, disabled: __props.disabled }]),
    style: _normalizeStyle({ backgroundColor: __props.bgColor })
  }, [
    (!!__props.isPlusActive)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(btnText)), 1),
    (!!__props.isArrowStyle)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_10))
      : _createCommentVNode("", true)
  ], 14, _hoisted_1))
}
}

})